export default class EntityHelper {
  constructor(ctx) {
    this.ctx = ctx
  }

  setMasterDataState(myProperty,state,singleMode)
  {
    if (singleMode)
      this.clearMasterDataState();

    var masterDataState=this.ctx.$store.getters.masterDataState;
    masterDataState[myProperty]=state;
    this.ctx.$store.dispatch("setMasterDataState", masterDataState);
  }

  clearMasterDataState()
  {
    var masterDataState=this.ctx.$store.getters.masterDataState;
    for (var property in masterDataState) {
      if (Object.prototype.hasOwnProperty.call(masterDataState, property))
        masterDataState[property]=false;
    }
    this.ctx.$store.dispatch("setMasterDataState", masterDataState);
  }

  setCustomerState(state)
  {
    if (state)
    {
      //read rabatte
      this.ctx.webService.getItems(this.ctx.$store.getters.rabatteBase)
        .then(response => {
          this.ctx.$store.dispatch("setRabattList", response.data);
        })
        .catch(err => { console.log(err) });

      //read customer data
      this.ctx.webService.getItems(this.ctx.$store.getters.customersBase)
        .then(response => {
          this.ctx.$store.dispatch("setCustomerList", response.data);
        })
        .catch(err => { console.log(err) });
    }
    this.setMasterDataState("showCustomer", state, true)
  }

  setLieferantState(state)
  {
    if (state)
    {
      //read konditionen
      this.ctx.webService.getItems(this.ctx.$store.getters.konditionenBase)
        .then(response => {
          this.ctx.$store.dispatch("setKonditionList", response.data);
        })
        .catch(err => { console.log(err) });

      //read lieferant data
      this.ctx.webService.getItems(this.ctx.$store.getters.lieferantBase)
        .then(response => {
          this.ctx.$store.dispatch("setLieferantenList", response.data);
        })
        .catch(err => { console.log(err) });
    }
    this.setMasterDataState("showLieferant", state, true)
  }

  setLieferadresseState(state,keys)
  {
    if (state)
    {
      //read lieferadressen data
      this.ctx.webService.getChildItems(this.ctx.$store.getters.lieferadresseBase,keys)
        .then(response => {
          this.ctx.$store.dispatch("setLieferadresseList", response.data);
        })
        .catch(err => { console.log(err) });
    }
    this.setMasterDataState("showLieferadresse", state, false)
  }

  setFakturaPosState(state)
  {
    this.setMasterDataState("showFakturaPos", state, false)
  }

  setProductState(state)
  {
    if (state)
    {
      //read taxes
      this.ctx.webService.getItems(this.ctx.$store.getters.taxesBase)
        .then(response => {
          this.ctx.$store.dispatch("setTaxList", response.data);
        })
        .catch(err => { console.log(err) });

      //read wgruppen
      this.ctx.webService.getItems(this.ctx.$store.getters.wgruppenBase)
        .then(response => {
          this.ctx.$store.dispatch("setWgruppenList", response.data);
        })
        .catch(err => { console.log(err) });

      //read product data
      this.ctx.webService.getItems(this.ctx.$store.getters.productsBase)
        .then(response => {
          this.ctx.$store.dispatch("setProductList", response.data);
        })
        .catch(err => { console.log(err) });
    }
    this.setMasterDataState("showProduct", state, true)
  }

  setServiceState(state)
  {
    if (state)
    {
      //read taxes
      this.ctx.webService.getItems(this.ctx.$store.getters.taxesBase)
        .then(response => {
          this.ctx.$store.dispatch("setTaxList", response.data);
        })
        .catch(err => { console.log(err) });

      //read service data
      this.ctx.webService.getItems(this.ctx.$store.getters.servicesBase)
        .then(response => {
          this.ctx.$store.dispatch("setServiceList", response.data);
        })
        .catch(err => { console.log(err) });
    }
    this.setMasterDataState("showService", state, true)
  }

  setTaxState(state)
  {
    if (state)
    {
      //read taxes
      this.ctx.webService.getItems(this.ctx.$store.getters.taxesBase)
        .then(response => {
          this.ctx.$store.dispatch("setTaxList", response.data);
        })
        .catch(err => { console.log(err) });
    }
    this.setMasterDataState("showTax", state, true)
  }

  setWgruppeState(state)
  {
    if (state)
    {
      //read wgruppen
      this.ctx.webService.getItems(this.ctx.$store.getters.wgruppenBase)
        .then(response => {
          this.ctx.$store.dispatch("setWgruppenList", response.data);
        })
        .catch(err => { console.log(err) });
    }
    this.setMasterDataState("showWgruppe", state, true)
  }

  setRabattState(state)
  {
    if (state)
    {
      //read rabatte
      this.ctx.webService.getItems(this.ctx.$store.getters.rabatteBase)
        .then(response => {
          this.ctx.$store.dispatch("setRabattList", response.data);
        })
        .catch(err => { console.log(err) });
    }
    this.setMasterDataState("showRabatt", state, true)
  }

  setKonditionState(state)
  {
    if (state)
    {
      //read konditionen
      this.ctx.webService.getItems(this.ctx.$store.getters.konditionenBase)
        .then(response => {
          this.ctx.$store.dispatch("setKonditionList", response.data);
        })
        .catch(err => { console.log(err) });
    }
    this.setMasterDataState("showKondition", state, true)
  }

  setFZeileState(state)
  {
    if (state)
    {
      //read Fakturaschlusszeilen
      this.ctx.webService.getItems(this.ctx.$store.getters.fzeileBase)
        .then(response => {
          this.ctx.$store.dispatch("setFzeileList", response.data);
        })
        .catch(err => { console.log(err) });
    }
    this.setMasterDataState("showFzeile", state, true)
  }

  setMahntextState(state)
  {
    if (state)
    {
      //read Mahntexte
      this.ctx.webService.getItems(this.ctx.$store.getters.mahntextBase)
        .then(response => {
          this.ctx.$store.dispatch("setMahntextList", response.data);
        })
        .catch(err => { console.log(err) });
    }
    this.setMasterDataState("showMahntext", state, true)
  }

  setBankkontoState(state)
  {
    if (state)
    {
      //read Bankkonti
      this.ctx.webService.getItems(this.ctx.$store.getters.bankkontoBase)
        .then(response => {
          this.ctx.$store.dispatch("setBankkontoList", response.data);
        })
        .catch(err => { console.log(err) });
    }
    this.setMasterDataState("showBankkonto", state, true)
  }

  setUserState(state)
  {
    if (state)
    {
      //read taxes
      this.ctx.webService.getItems(this.ctx.$store.getters.taxesBase)
        .then(response => {
          this.ctx.$store.dispatch("setTaxList", response.data);
        })
        .catch(err => { console.log(err) });

      //read Users
      if (this.ctx.authorityHelper.hasRoleAdmin())
      {
        this.ctx.webService.getItems(this.ctx.$store.getters.userBase)
          .then(response => {
            this.ctx.$store.dispatch("setUserList", response.data);
          })
          .catch(err => { console.log(err) });
      }
      else
      {
        this.ctx.webService.getUser(this.ctx.$store.getters.getUser, this.ctx.$store.getters.username)
          .then(response => {
            this.ctx.$store.dispatch("setUserList", [response.data]);
          })
          .catch(err => { console.log(err) });
      }
    }
    this.setMasterDataState("showUser", state, true)
  }

  setFakturaState(state, docType)
  {
    if (state)
    {
      //read customer data
      this.ctx.webService.getItems(this.ctx.$store.getters.customersBase)
        .then(response => {
          this.ctx.$store.dispatch("setCustomerList", response.data);
        })
        .catch(err => { console.log(err) });

      //read rabatte
      this.ctx.webService.getItems(this.ctx.$store.getters.rabatteBase)
        .then(response => {
          this.ctx.$store.dispatch("setRabattList", response.data);
        })
        .catch(err => { console.log(err) });

      //read konditionen
      this.ctx.webService.getItems(this.ctx.$store.getters.konditionenBase)
        .then(response => {
          this.ctx.$store.dispatch("setKonditionList", response.data);
        })
        .catch(err => { console.log(err) });

      //read Fakturaschlusszeilen
      this.ctx.webService.getItems(this.ctx.$store.getters.fzeileBase)
        .then(response => {
          this.ctx.$store.dispatch("setFzeileList", response.data);
        })
        .catch(err => { console.log(err) });
        
      //read Mahntexte
      this.ctx.webService.getItems(this.ctx.$store.getters.mahntextBase)
        .then(response => {
          this.ctx.$store.dispatch("setMahntextList", response.data);
        })
        .catch(err => { console.log(err) });

      //read Bankkonti
      this.ctx.webService.getItems(this.ctx.$store.getters.bankkontoBase)
        .then(response => {
          this.ctx.$store.dispatch("setBankkontoList", response.data);
        })
        .catch(err => { console.log(err) });

      //read faktura
      this.ctx.webService.getItems(this.ctx.$store.getters.fakturaEntities+"/"+docType.toString())
        .then(response => {
          this.ctx.$store.dispatch("setFakturaList", response.data);
        })
        .catch(err => { console.log(err) });
    }

    switch (docType) {
      case this.ctx.$store.getters.FAKTURA_FAKTURA:
        this.setMasterDataState("showFaktura", state, true)
        break;
      case this.ctx.$store.getters.FAKTURA_VERBUCHT:
        this.setMasterDataState("showFakturaVerbucht", state, true)
        break;
      case this.ctx.$store.getters.FAKTURA_RAPPORT:
        this.setMasterDataState("showRapport", state, true)
        break;
      case this.ctx.$store.getters.FAKTURA_OFFERTE:
        this.setMasterDataState("showOfferte", state, true)
        break;
      case this.ctx.$store.getters.FAKTURA_AUFTRAG:
        this.setMasterDataState("showAuftrag", state, true)
        break;
      case this.ctx.$store.getters.FAKTURA_ARCHIV:
        this.setMasterDataState("showFakturaArchiv", state, true)
        break;
      default:
        console.log('wrong docType param');
    }
  }

  setWeingangState(state)
  {
    if (state)
    {
      //read product data
      this.ctx.webService.getItems(this.ctx.$store.getters.productsBase)
        .then(response => {
          this.ctx.$store.dispatch("setProductList", response.data);
        })
        .catch(err => { console.log(err) });
        
      //read lieferant data
      this.ctx.webService.getItems(this.ctx.$store.getters.lieferantBase)
        .then(response => {
          this.ctx.$store.dispatch("setLieferantenList", response.data);
        })
        .catch(err => { console.log(err) });

      //read Wareneingänge
      this.ctx.webService.getItems(this.ctx.$store.getters.weingangBase)
        .then(response => {
          this.ctx.$store.dispatch("setWeingangList", response.data);
        })
        .catch(err => { console.log(err) });
    }
    this.setMasterDataState("showWeingang", state, true)
  }

}
